import React, { useState, useEffect } from 'react';
import { getProjects, addProject, deleteProject, Project } from '../utils/projectStorage';

const Admin: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [projects, setProjects] = useState<Project[]>([]);
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    year: new Date().getFullYear().toString(),
    description: '',
    image: '',
    images: [] as string[],
    icon: '🏠'
  });

  useEffect(() => {
    if (isAuthenticated) {
      loadProjects();
    }
  }, [isAuthenticated]);

  const loadProjects = () => {
    const loadedProjects = getProjects();
    setProjects(loadedProjects);
  };

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'admin123') {
      setIsAuthenticated(true);
    } else {
      alert('Yanlış şifre!');
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const newProject = addProject(formData);
    setProjects([...projects, newProject]);
    setFormData({
      title: '',
      category: '',
      year: new Date().getFullYear().toString(),
      description: '',
      image: '',
      images: [],
      icon: '🏠'
    });
    alert('Proje başarıyla eklendi!');
  };

  const handleDelete = (id: number) => {
    if (window.confirm('Bu projeyi silmek istediğinizden emin misiniz?')) {
      deleteProject(id);
      setProjects(projects.filter(p => p.id !== id));
      alert('Proje silindi!');
    }
  };

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({ ...formData, image: reader.result as string });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleMultipleImagesUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const fileArray = Array.from(files);
      
      // Toplam resim sayısı kontrolü
      if (formData.images.length + fileArray.length > 10) {
        alert('Maksimum 10 resim ekleyebilirsiniz!');
        return;
      }
      
      const readers = fileArray.map(file => {
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = () => reject(new Error('Resim yüklenemedi'));
          reader.readAsDataURL(file);
        });
      });

      Promise.all(readers)
        .then(images => {
          setFormData({ ...formData, images: [...formData.images, ...images] });
          alert(`${images.length} resim başarıyla eklendi!`);
        })
        .catch(error => {
          alert('Resimler yüklenirken hata oluştu: ' + error.message);
        });
    }
  };

  const removeImage = (index: number) => {
    const newImages = formData.images.filter((_, i) => i !== index);
    setFormData({ ...formData, images: newImages });
  };

  const categoryIcons: { [key: string]: string } = {
    'Konut': '🏠',
    'Ticari': '🏢',
    'Restorasyon': '🏛️',
    '3D Modelleme': '🎨'
  };

  if (!isAuthenticated) {
    return (
      <div className="hero">
        <div className="container" style={{maxWidth: '500px'}}>
          <div className="card fade-in-up" style={{padding: 'var(--spacing-lg)'}}>
            <h1 className="heading-1 text-center mb-lg">Admin Paneli</h1>
            <form onSubmit={handleLogin}>
              <div style={{marginBottom: 'var(--spacing-md)'}}>
                <label className="body-base text-secondary" style={{display: 'block', marginBottom: 'var(--spacing-xs)'}}>
                  Şifre
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    background: 'var(--color-bg-dark)',
                    border: '1px solid var(--color-border)',
                    color: 'var(--color-text-primary)',
                    fontFamily: 'var(--font-body)',
                    fontSize: '1rem'
                  }}
                  placeholder="Şifrenizi girin"
                />
              </div>
              <button type="submit" className="btn btn-primary" style={{width: '100%'}}>
                Giriş Yap
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{paddingTop: '100px', minHeight: '100vh', paddingBottom: '4rem'}}>
      <div className="container">
        <div className="flex-between mb-lg">
          <h1 className="heading-1">Proje Yönetimi</h1>
          <button 
            onClick={() => setIsAuthenticated(false)} 
            className="btn btn-outline"
          >
            Çıkış Yap
          </button>
        </div>

        {/* Add Project Form */}
        <div className="card mb-lg" style={{padding: 'var(--spacing-lg)'}}>
          <h2 className="heading-2 mb-md">Yeni Proje Ekle</h2>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-2 gap-md">
              <div>
                <label className="body-small text-secondary" style={{display: 'block', marginBottom: 'var(--spacing-xs)'}}>
                  Proje Başlığı *
                </label>
                <input
                  type="text"
                  required
                  value={formData.title}
                  onChange={(e) => setFormData({...formData, title: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    background: 'var(--color-bg-dark)',
                    border: '1px solid var(--color-border)',
                    color: 'var(--color-text-primary)',
                    fontFamily: 'var(--font-body)'
                  }}
                />
              </div>
              <div>
                <label className="body-small text-secondary" style={{display: 'block', marginBottom: 'var(--spacing-xs)'}}>
                  Kategori *
                </label>
                <select
                  required
                  value={formData.category}
                  onChange={(e) => {
                    const category = e.target.value;
                    setFormData({
                      ...formData, 
                      category,
                      icon: categoryIcons[category] || '🏠'
                    });
                  }}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    background: 'var(--color-bg-dark)',
                    border: '1px solid var(--color-border)',
                    color: 'var(--color-text-primary)',
                    fontFamily: 'var(--font-body)'
                  }}
                >
                  <option value="">Seçiniz</option>
                  <option value="Konut">Konut 🏠</option>
                  <option value="Ticari">Ticari 🏢</option>
                  <option value="Restorasyon">Restorasyon 🏛️</option>
                  <option value="3D Modelleme">3D Modelleme 🎨</option>
                </select>
              </div>
            </div>

            <div style={{marginTop: 'var(--spacing-md)'}}>
              <label className="body-small text-secondary" style={{display: 'block', marginBottom: 'var(--spacing-xs)'}}>
                Yıl *
              </label>
              <input
                type="text"
                required
                value={formData.year}
                onChange={(e) => setFormData({...formData, year: e.target.value})}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: 'var(--color-bg-dark)',
                  border: '1px solid var(--color-border)',
                  color: 'var(--color-text-primary)',
                  fontFamily: 'var(--font-body)'
                }}
              />
            </div>

            <div style={{marginTop: 'var(--spacing-md)'}}>
              <label className="body-small text-secondary" style={{display: 'block', marginBottom: 'var(--spacing-xs)'}}>
                Açıklama *
              </label>
              <textarea
                required
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                rows={4}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: 'var(--color-bg-dark)',
                  border: '1px solid var(--color-border)',
                  color: 'var(--color-text-primary)',
                  fontFamily: 'var(--font-body)',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{marginTop: 'var(--spacing-md)'}}>
              <label className="body-small text-secondary" style={{display: 'block', marginBottom: 'var(--spacing-xs)'}}>
                Kapak Görseli (Opsiyonel)
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: 'var(--color-bg-dark)',
                  border: '1px solid var(--color-border)',
                  color: 'var(--color-text-primary)',
                  fontFamily: 'var(--font-body)'
                }}
              />
              {formData.image && (
                <div style={{marginTop: 'var(--spacing-sm)'}}>
                  <img 
                    src={formData.image} 
                    alt="Preview" 
                    style={{maxWidth: '200px', height: 'auto', border: '1px solid var(--color-border)'}}
                  />
                </div>
              )}
            </div>

            <div style={{marginTop: 'var(--spacing-md)'}}>
              <label className="body-small text-secondary" style={{display: 'block', marginBottom: 'var(--spacing-xs)'}}>
                Proje Görselleri (Çoklu - Opsiyonel)
              </label>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleMultipleImagesUpload}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: 'var(--color-bg-dark)',
                  border: '1px solid var(--color-border)',
                  color: 'var(--color-text-primary)',
                  fontFamily: 'var(--font-body)'
                }}
              />
              {formData.images.length > 0 && (
                <div style={{marginTop: 'var(--spacing-sm)', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '1rem'}}>
                  {formData.images.map((img, index) => (
                    <div key={index} style={{position: 'relative'}}>
                      <img 
                        src={img} 
                        alt={`Preview ${index + 1}`} 
                        style={{width: '100%', height: '150px', objectFit: 'cover', border: '1px solid var(--color-border)'}}
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: 'absolute',
                          top: '5px',
                          right: '5px',
                          background: 'var(--color-accent)',
                          color: 'var(--color-primary)',
                          border: 'none',
                          borderRadius: '50%',
                          width: '25px',
                          height: '25px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button type="submit" className="btn btn-primary" style={{marginTop: 'var(--spacing-md)'}}>
              Proje Ekle
            </button>
          </form>
        </div>

        {/* Projects List */}
        <div>
          <h2 className="heading-2 mb-md">Mevcut Projeler ({projects.length})</h2>
          {projects.length === 0 ? (
            <div className="card" style={{padding: 'var(--spacing-lg)', textAlign: 'center'}}>
              <p className="body-base text-secondary">Henüz proje eklenmemiş</p>
            </div>
          ) : (
            <div className="grid grid-3">
              {projects.map((project) => (
                <div key={project.id} className="card">
                  {project.image ? (
                    <img 
                      src={project.image} 
                      alt={project.title}
                      style={{width: '100%', height: '200px', objectFit: 'cover'}}
                    />
                  ) : (
                    <div className="img-placeholder" style={{height: '200px'}}>
                      <span style={{fontSize: '4rem'}}>{project.icon}</span>
                    </div>
                  )}
                  <div style={{padding: 'var(--spacing-md)'}}>
                    <p className="body-small accent-text mb-sm">{project.category} • {project.year}</p>
                    <h3 className="heading-3 mb-sm">{project.title}</h3>
                    <p className="body-small text-secondary mb-md">{project.description}</p>
                    <button 
                      onClick={() => handleDelete(project.id)}
                      className="btn btn-outline"
                      style={{width: '100%', padding: '0.5rem 1rem', fontSize: '0.75rem'}}
                    >
                      Sil
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Admin;
